export const environment = {
  production: false,
  // rootUrlApi: 'http://api-toobook.com/api/site/'
  // rootUrlApi: 'http://api-toobook.local/api/site/'
  rootUrlApi: 'https://homologacao.toobook.com.br/api/site/'
};
